import clsx from 'clsx';

export function cn(...classes: (string | undefined | null | false)[]): string {
  return clsx(classes);
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatDateTime(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    draft: 'bg-gray-100 text-gray-800',
    quoted: 'bg-blue-100 text-blue-800',
    paid: 'bg-green-100 text-green-800',
    building: 'bg-yellow-100 text-yellow-800',
    qa: 'bg-orange-100 text-orange-800',
    staging: 'bg-purple-100 text-purple-800',
    live: 'bg-green-100 text-green-800',
    pending: 'bg-yellow-100 text-yellow-800',
    approved: 'bg-blue-100 text-blue-800',
    expired: 'bg-red-100 text-red-800',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

export function capitalizeFirst(str: string): string {
  const safeStr = String(str || '');
  return safeStr.charAt(0).toUpperCase() + safeStr.slice(1);
}

export function formatCurrency(value: unknown): string {
  const num = Number(value) || 0;
  return `R ${num.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatNumber(value: unknown): string {
  return (Number(value) || 0).toLocaleString();
}

export function formatPercentage(value: unknown): string {
  return `${(Number(value) || 0).toFixed(1)}%`;
}
